<template>
    <CButton
        class="relative !text-gray-600 dark:!text-gray-400 hover:!text-gray-900 dark:hover:!text-gray-200 !no-underline hover:!no-underline"
        :disabled="preview"
        icon="report"
        size="small"
        variant="text"
        @click="reportObjectTrackExponea()"
    >
        <CLiveAgentLink
            id="reportOpportunityBtn"
            class="!no-underline"
            :hide-text-on-mobile="hideTextOnMobile"
            :text="$t('reportBtn.report', lang)"
            with-icon
        />
    </CButton>
</template>

<script setup lang="ts">
import { useApplicationStore } from '@/stores/application'
import CButton from '@/components/ui/CButton.vue'
import CLiveAgentLink from '@/components/ui/CLiveAgentLink.vue'
import { useExponea } from '@/composables/exponea/useExponea'
import { useLiveAgent } from '@/composables/liveAgent/useLiveAgent'

interface Props {
    id?: string
    lang?: string
    preview?: boolean
    type: string
    title: string
    hideTextOnMobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    id: undefined,
    lang: 'sk',
    preview: false,
    hideTextOnMobile: false
})

const applicationStore = useApplicationStore()
const liveAgent = useLiveAgent()
const { track } = useExponea()

useHead(() => ({
    script: liveAgent.liveAgentHeadScript([
        {
            liveAgentId: 'b3xi97ye',
            elementId: 'reportOpportunityBtn'
        }
    ]).script
}))

const reportObjectTrackExponea = () => {
    if (props.preview) {
        return
    }

    track('cta1_report_opportunity', {
        type: props.type,
        title: props.title,
        itemId: props.id
    })
}
</script>
